
const responseSampleData = {
  data: {
    apiResponseTimes: [
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:33:00.890Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29.5,
          },
          {
            percentile: '95.0',
            value: 48,
          },
          {
            percentile: '99.0',
            value: 51.16,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb4f87bf2c9098419b5e8',
        createdAt: 1537979640931,
        updatedAt: 1537979640931,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:32:00.952Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 31,
          },
          {
            percentile: '95.0',
            value: 193.1999999999996,
          },
          {
            percentile: '99.0',
            value: 260.7599999999999,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 26,
        objectId: '5babb4bca959fa097f5aa773',
        createdAt: 1537979580982,
        updatedAt: 1537979580982,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:31:01.577Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 59.39999999999999,
          },
          {
            percentile: '99.0',
            value: 85.74000000000004,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb4813e5b7c09653e6d5f',
        createdAt: 1537979521621,
        updatedAt: 1537979521621,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:30:01.082Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28,
          },
          {
            percentile: '95.0',
            value: 418.75,
          },
          {
            percentile: '99.0',
            value: 555.75,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 26,
          },
        ],
        totalrequest: 26,
        objectId: '5babb445a959fa097f5aa76b',
        createdAt: 1537979461117,
        updatedAt: 1537979461117,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:29:02.692Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 49.8,
          },
          {
            percentile: '99.0',
            value: 50.79,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb40a8fd6f6097411f851',
        createdAt: 1537979402737,
        updatedAt: 1537979402737,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:28:02.195Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27,
          },
          {
            percentile: '95.0',
            value: 55.19999999999999,
          },
          {
            percentile: '99.0',
            value: 70.82000000000002,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb3cea959fa097f5aa760',
        createdAt: 1537979342234,
        updatedAt: 1537979342234,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:27:00.874Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32.5,
          },
          {
            percentile: '95.0',
            value: 49.55,
          },
          {
            percentile: '99.0',
            value: 55.38999999999999,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb390b89e55096ae994fc',
        createdAt: 1537979280902,
        updatedAt: 1537979280902,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:26:00.832Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28,
          },
          {
            percentile: '95.0',
            value: 191.59999999999997,
          },
          {
            percentile: '99.0',
            value: 205.22,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 28,
        objectId: '5babb354b89e55096ae994fb',
        createdAt: 1537979220861,
        updatedAt: 1537979220861,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:25:00.861Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 31,
          },
          {
            percentile: '95.0',
            value: 54.8,
          },
          {
            percentile: '99.0',
            value: 1593.1600000000021,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb3187bf2c9098419b5c5',
        createdAt: 1537979160900,
        updatedAt: 1537979160900,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:24:02.017Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27.5,
          },
          {
            percentile: '95.0',
            value: 54,
          },
          {
            percentile: '99.0',
            value: 73.25,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb2de8fd6f6097411f836',
        createdAt: 1537979102052,
        updatedAt: 1537979102052,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:23:00.959Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28.5,
          },
          {
            percentile: '95.0',
            value: 52.95,
          },
          {
            percentile: '99.0',
            value: 55.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb2a1b89e55096ae994ea',
        createdAt: 1537979041002,
        updatedAt: 1537979041002,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:22:00.874Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29.5,
          },
          {
            percentile: '95.0',
            value: 47.95,
          },
          {
            percentile: '99.0',
            value: 50.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb264281225096b834c92',
        createdAt: 1537978980922,
        updatedAt: 1537978980922,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:21:00.922Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 54,
          },
          {
            percentile: '99.0',
            value: 142.14000000000013,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb228a959fa097f5aa739',
        createdAt: 1537978920958,
        updatedAt: 1537978920958,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:20:00.894Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 247.2,
          },
          {
            percentile: '99.0',
            value: 274.0799999999999,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 26,
        objectId: '5babb1ec3e5b7c09653e6d2d',
        createdAt: 1537978860925,
        updatedAt: 1537978860925,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:19:01.881Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 34,
          },
          {
            percentile: '95.0',
            value: 527.5,
          },
          {
            percentile: '99.0',
            value: 1450.75,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 26,
          },
        ],
        totalrequest: 26,
        objectId: '5babb1b1f224d6097abba69c',
        createdAt: 1537978801931,
        updatedAt: 1537978801931,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:18:00.880Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 25.5,
          },
          {
            percentile: '95.0',
            value: 63.79999999999998,
          },
          {
            percentile: '99.0',
            value: 81.17,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb1747bf2c9098419b5a7',
        createdAt: 1537978740922,
        updatedAt: 1537978740922,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:17:00.962Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 56,
          },
          {
            percentile: '99.0',
            value: 84.11999999999992,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 25,
        objectId: '5babb139f7d9610979c15b49',
        createdAt: 1537978681004,
        updatedAt: 1537978681004,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:16:00.954Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 26,
          },
          {
            percentile: '95.0',
            value: 49,
          },
          {
            percentile: '99.0',
            value: 49,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 21,
          },
        ],
        totalrequest: 21,
        objectId: '5babb0fcf224d6097abba688',
        createdAt: 1537978620997,
        updatedAt: 1537978620997,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:15:00.856Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 36,
          },
          {
            percentile: '95.0',
            value: 205.19999999999996,
          },
          {
            percentile: '99.0',
            value: 263.43999999999994,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 28,
        objectId: '5babb0c0b89e55096ae994cb',
        createdAt: 1537978560900,
        updatedAt: 1537978560900,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:14:02.697Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 715.6999999999996,
          },
          {
            percentile: '99.0',
            value: 1734.9999999999982,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 27,
        objectId: '5babb086a959fa097f5aa712',
        createdAt: 1537978502757,
        updatedAt: 1537978502757,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:13:00.875Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32,
          },
          {
            percentile: '95.0',
            value: 54.05000000000002,
          },
          {
            percentile: '99.0',
            value: 70.00999999999998,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babb048a959fa097f5aa70a',
        createdAt: 1537978440910,
        updatedAt: 1537978440910,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:12:00.959Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28.5,
          },
          {
            percentile: '95.0',
            value: 52.150000000000006,
          },
          {
            percentile: '99.0',
            value: 54.42999999999999,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babb00d8fd6f6097411f7e9',
        createdAt: 1537978381032,
        updatedAt: 1537978381032,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:11:00.888Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27.5,
          },
          {
            percentile: '95.0',
            value: 49.050000000000004,
          },
          {
            percentile: '99.0',
            value: 49.81,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babafd0f7d9610979c15b2a',
        createdAt: 1537978320969,
        updatedAt: 1537978320969,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:10:00.915Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27,
          },
          {
            percentile: '95.0',
            value: 52,
          },
          {
            percentile: '99.0',
            value: 74.40000000000002,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 21,
          },
        ],
        totalrequest: 21,
        objectId: '5babaf94f7d9610979c15b28',
        createdAt: 1537978260956,
        updatedAt: 1537978260956,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:09:02.460Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30,
          },
          {
            percentile: '95.0',
            value: 219.19999999999993,
          },
          {
            percentile: '99.0',
            value: 378.6600000000002,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 24,
        objectId: '5babaf5af7d9610979c15b24',
        createdAt: 1537978202488,
        updatedAt: 1537978202488,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:08:00.876Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 59.599999999999994,
          },
          {
            percentile: '99.0',
            value: 78.95999999999998,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babaf1c3e5b7c09653e6cf2',
        createdAt: 1537978140910,
        updatedAt: 1537978140910,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:07:00.904Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30,
          },
          {
            percentile: '95.0',
            value: 52.699999999999996,
          },
          {
            percentile: '99.0',
            value: 102.14000000000007,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babaee0a959fa097f5aa6e0',
        createdAt: 1537978080935,
        updatedAt: 1537978080935,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:06:00.920Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30.5,
          },
          {
            percentile: '95.0',
            value: 52.900000000000006,
          },
          {
            percentile: '99.0',
            value: 54.58,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babaea43e5b7c09653e6cd6',
        createdAt: 1537978020977,
        updatedAt: 1537978020977,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:05:00.896Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 35.5,
          },
          {
            percentile: '95.0',
            value: 57,
          },
          {
            percentile: '99.0',
            value: 59.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babae68b89e55096ae9948f',
        createdAt: 1537977960957,
        updatedAt: 1537977960957,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:04:02.173Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32.5,
          },
          {
            percentile: '95.0',
            value: 53,
          },
          {
            percentile: '99.0',
            value: 53.79,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babae2e3e5b7c09653e6cc8',
        createdAt: 1537977902236,
        updatedAt: 1537977902236,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/version',
        time_bucket: '2018-09-26T16:03:00.910Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 47,
          },
          {
            percentile: '95.0',
            value: 566.5,
          },
          {
            percentile: '99.0',
            value: 1655.8999999999992,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 31,
          },
        ],
        totalrequest: 32,
        objectId: '5babadf03e5b7c09653e6cc2',
        createdAt: 1537977840938,
        updatedAt: 1537977840938,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:33:00.890Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29.5,
          },
          {
            percentile: '95.0',
            value: 48,
          },
          {
            percentile: '99.0',
            value: 51.16,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb4f87bf2c9098419b5e8',
        createdAt: 1537979640931,
        updatedAt: 1537979640931,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:32:00.952Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 31,
          },
          {
            percentile: '95.0',
            value: 193.1999999999996,
          },
          {
            percentile: '99.0',
            value: 260.7599999999999,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 26,
        objectId: '5babb4bca959fa097f5aa773',
        createdAt: 1537979580982,
        updatedAt: 1537979580982,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:31:01.577Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 59.39999999999999,
          },
          {
            percentile: '99.0',
            value: 85.74000000000004,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb4813e5b7c09653e6d5f',
        createdAt: 1537979521621,
        updatedAt: 1537979521621,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:30:01.082Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28,
          },
          {
            percentile: '95.0',
            value: 418.75,
          },
          {
            percentile: '99.0',
            value: 555.75,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 26,
          },
        ],
        totalrequest: 26,
        objectId: '5babb445a959fa097f5aa76b',
        createdAt: 1537979461117,
        updatedAt: 1537979461117,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:29:02.692Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 49.8,
          },
          {
            percentile: '99.0',
            value: 50.79,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb40a8fd6f6097411f851',
        createdAt: 1537979402737,
        updatedAt: 1537979402737,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:28:02.195Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27,
          },
          {
            percentile: '95.0',
            value: 55.19999999999999,
          },
          {
            percentile: '99.0',
            value: 70.82000000000002,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb3cea959fa097f5aa760',
        createdAt: 1537979342234,
        updatedAt: 1537979342234,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:27:00.874Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32.5,
          },
          {
            percentile: '95.0',
            value: 49.55,
          },
          {
            percentile: '99.0',
            value: 55.38999999999999,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb390b89e55096ae994fc',
        createdAt: 1537979280902,
        updatedAt: 1537979280902,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:26:00.832Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28,
          },
          {
            percentile: '95.0',
            value: 191.59999999999997,
          },
          {
            percentile: '99.0',
            value: 205.22,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 28,
        objectId: '5babb354b89e55096ae994fb',
        createdAt: 1537979220861,
        updatedAt: 1537979220861,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:25:00.861Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 31,
          },
          {
            percentile: '95.0',
            value: 54.8,
          },
          {
            percentile: '99.0',
            value: 1593.1600000000021,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb3187bf2c9098419b5c5',
        createdAt: 1537979160900,
        updatedAt: 1537979160900,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:24:02.017Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27.5,
          },
          {
            percentile: '95.0',
            value: 54,
          },
          {
            percentile: '99.0',
            value: 73.25,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb2de8fd6f6097411f836',
        createdAt: 1537979102052,
        updatedAt: 1537979102052,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:23:00.959Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28.5,
          },
          {
            percentile: '95.0',
            value: 52.95,
          },
          {
            percentile: '99.0',
            value: 55.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb2a1b89e55096ae994ea',
        createdAt: 1537979041002,
        updatedAt: 1537979041002,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:22:00.874Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29.5,
          },
          {
            percentile: '95.0',
            value: 47.95,
          },
          {
            percentile: '99.0',
            value: 50.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babb264281225096b834c92',
        createdAt: 1537978980922,
        updatedAt: 1537978980922,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:21:00.922Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 54,
          },
          {
            percentile: '99.0',
            value: 142.14000000000013,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babb228a959fa097f5aa739',
        createdAt: 1537978920958,
        updatedAt: 1537978920958,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:20:00.894Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 247.2,
          },
          {
            percentile: '99.0',
            value: 274.0799999999999,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 26,
        objectId: '5babb1ec3e5b7c09653e6d2d',
        createdAt: 1537978860925,
        updatedAt: 1537978860925,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:19:01.881Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 34,
          },
          {
            percentile: '95.0',
            value: 527.5,
          },
          {
            percentile: '99.0',
            value: 1450.75,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 26,
          },
        ],
        totalrequest: 26,
        objectId: '5babb1b1f224d6097abba69c',
        createdAt: 1537978801931,
        updatedAt: 1537978801931,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:18:00.880Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 25.5,
          },
          {
            percentile: '95.0',
            value: 63.79999999999998,
          },
          {
            percentile: '99.0',
            value: 81.17,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 24,
          },
        ],
        totalrequest: 24,
        objectId: '5babb1747bf2c9098419b5a7',
        createdAt: 1537978740922,
        updatedAt: 1537978740922,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:17:00.962Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 33,
          },
          {
            percentile: '95.0',
            value: 56,
          },
          {
            percentile: '99.0',
            value: 84.11999999999992,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 25,
          },
        ],
        totalrequest: 25,
        objectId: '5babb139f7d9610979c15b49',
        createdAt: 1537978681004,
        updatedAt: 1537978681004,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:16:00.954Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 26,
          },
          {
            percentile: '95.0',
            value: 49,
          },
          {
            percentile: '99.0',
            value: 49,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 21,
          },
        ],
        totalrequest: 21,
        objectId: '5babb0fcf224d6097abba688',
        createdAt: 1537978620997,
        updatedAt: 1537978620997,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:15:00.856Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 36,
          },
          {
            percentile: '95.0',
            value: 205.19999999999996,
          },
          {
            percentile: '99.0',
            value: 263.43999999999994,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 28,
        objectId: '5babb0c0b89e55096ae994cb',
        createdAt: 1537978560900,
        updatedAt: 1537978560900,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:14:02.697Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 715.6999999999996,
          },
          {
            percentile: '99.0',
            value: 1734.9999999999982,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 27,
          },
        ],
        totalrequest: 27,
        objectId: '5babb086a959fa097f5aa712',
        createdAt: 1537978502757,
        updatedAt: 1537978502757,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:13:00.875Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32,
          },
          {
            percentile: '95.0',
            value: 54.05000000000002,
          },
          {
            percentile: '99.0',
            value: 70.00999999999998,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babb048a959fa097f5aa70a',
        createdAt: 1537978440910,
        updatedAt: 1537978440910,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:12:00.959Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 28.5,
          },
          {
            percentile: '95.0',
            value: 52.150000000000006,
          },
          {
            percentile: '99.0',
            value: 54.42999999999999,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babb00d8fd6f6097411f7e9',
        createdAt: 1537978381032,
        updatedAt: 1537978381032,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:11:00.888Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27.5,
          },
          {
            percentile: '95.0',
            value: 49.050000000000004,
          },
          {
            percentile: '99.0',
            value: 49.81,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 20,
          },
        ],
        totalrequest: 20,
        objectId: '5babafd0f7d9610979c15b2a',
        createdAt: 1537978320969,
        updatedAt: 1537978320969,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:10:00.915Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 27,
          },
          {
            percentile: '95.0',
            value: 52,
          },
          {
            percentile: '99.0',
            value: 74.40000000000002,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 21,
          },
        ],
        totalrequest: 21,
        objectId: '5babaf94f7d9610979c15b28',
        createdAt: 1537978260956,
        updatedAt: 1537978260956,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:09:02.460Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30,
          },
          {
            percentile: '95.0',
            value: 219.19999999999993,
          },
          {
            percentile: '99.0',
            value: 378.6600000000002,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 24,
        objectId: '5babaf5af7d9610979c15b24',
        createdAt: 1537978202488,
        updatedAt: 1537978202488,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:08:00.876Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 29,
          },
          {
            percentile: '95.0',
            value: 59.599999999999994,
          },
          {
            percentile: '99.0',
            value: 78.95999999999998,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babaf1c3e5b7c09653e6cf2',
        createdAt: 1537978140910,
        updatedAt: 1537978140910,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:07:00.904Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30,
          },
          {
            percentile: '95.0',
            value: 52.699999999999996,
          },
          {
            percentile: '99.0',
            value: 102.14000000000007,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 23,
          },
        ],
        totalrequest: 23,
        objectId: '5babaee0a959fa097f5aa6e0',
        createdAt: 1537978080935,
        updatedAt: 1537978080935,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:06:00.920Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 30.5,
          },
          {
            percentile: '95.0',
            value: 52.900000000000006,
          },
          {
            percentile: '99.0',
            value: 54.58,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babaea43e5b7c09653e6cd6',
        createdAt: 1537978020977,
        updatedAt: 1537978020977,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:05:00.896Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 35.5,
          },
          {
            percentile: '95.0',
            value: 57,
          },
          {
            percentile: '99.0',
            value: 59.37,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babae68b89e55096ae9948f',
        createdAt: 1537977960957,
        updatedAt: 1537977960957,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:04:02.173Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 32.5,
          },
          {
            percentile: '95.0',
            value: 53,
          },
          {
            percentile: '99.0',
            value: 53.79,
          },
        ],
        status_counts: [
          {
            status_code: '200',
            status_count: 22,
          },
        ],
        totalrequest: 22,
        objectId: '5babae2e3e5b7c09653e6cc8',
        createdAt: 1537977902236,
        updatedAt: 1537977902236,
      },
      {
        servertype: 'hap_least_load',
        apimethod: 'GET /v1/catalog/nodes',
        time_bucket: '2018-09-26T16:03:00.910Z',
        percentiles: [
          {
            percentile: '50.0',
            value: 47,
          },
          {
            percentile: '95.0',
            value: 566.5,
          },
          {
            percentile: '99.0',
            value: 1655.8999999999992,
          },
        ],
        status_counts: [
          {
            status_code: '301',
            status_count: 1,
          },
          {
            status_code: '200',
            status_count: 31,
          },
        ],
        totalrequest: 32,
        objectId: '5babadf03e5b7c09653e6cc2',
        createdAt: 1537977840938,
        updatedAt: 1537977840938,
      },
    ],
  },
};

export default responseSampleData;
